import React, { ReactNode } from "react";

import { Layout } from "react-grid-layout";
import { IntlShape } from "react-intl";

import User from "@mapmycustomers/shared/types/User";

import GoalType from "@app/enum/dashboard/GoalType";
import DefaultTimeRangeFormComponent from "@app/scene/dashboard/components/cards/common/DefaultTimeRangeFormComponent";
import CardUiDescriptor from "@app/scene/dashboard/types/CardUiDescriptor";
import ActivitiesLoggedCardConfiguration from "@app/types/dashboard/cards/activitiesLogged/ActivitiesLoggedCardConfiguration";
import ActivitiesLoggedViewState from "@app/types/dashboard/cards/activitiesLogged/ActivitiesLoggedViewState";
import Scope from "@app/types/dashboard/Scope";
import { userDisplayName } from "@app/util/formatters";

import { GRID_WIDTH } from "../../DashboardContent/util/consts";
import DefaultPreferencesFormComponent from "../common/DefaultPreferencesFormComponent";
import GoalDetailsFormComponent from "../common/GoalDetailsFormComponent";

import CardContentComponent from "./CardContentComponent";
import CriteriaFormComponent from "./CriteriaFormComponent";
import messages from "./messages";

const activitiesLoggedCard: CardUiDescriptor<ActivitiesLoggedCardConfiguration> = {
  CardContentComponent,
  CriteriaFormComponent,
  DateRangeFormComponent: DefaultTimeRangeFormComponent,
  getCardDimensions({ configuration, viewState }): Pick<Layout, "h" | "w"> {
    // TODO: should change base h depending on whether the goal is enabled/disabled
    const dimensions = {
      h: 2,
      w: (viewState as ActivitiesLoggedViewState).fullWidth ? GRID_WIDTH : 4,
    };
    if (configuration.preferences.showChart) {
      dimensions.h += 2;
    }
    return dimensions;
  },
  getCardPlainTitle(intl, context): string {
    const dateRange = context.configuration.dateRange;
    return intl.formatMessage(messages.cardTitle, {
      date: (text: string[]) => text,
      dateRange: dateRange.range,
      dateSubRange: dateRange.subRange,
    }) as string;
  },
  getGoalDescription(intl: IntlShape, context: { scope: Scope }, users: User[]): ReactNode {
    const { scope } = context;
    if (scope.userId) {
      const user = users.find(({ id }) => id === scope.userId);
      return intl.formatMessage(messages.userGoal, {
        b: (text: ReactNode[]) => <b>{text}</b>,
        user: user ? userDisplayName(user) : intl.formatMessage(messages.user),
      });
    }
    return intl.formatMessage(scope.teamId ? messages.teamGoal : messages.orgGoal, {
      b: (text: ReactNode[]) => <b>{text}</b>,
    });
  },
  getGoalType() {
    return { format: "amount", goalType: GoalType.MIN_GOAL };
  },
  getModalTitle(intl): ReactNode {
    return intl.formatMessage(messages.modalTitle);
  },
  GoalDetailsComponent: GoalDetailsFormComponent,
  PreferencesFormComponent: DefaultPreferencesFormComponent,
};

export default activitiesLoggedCard;
